import React, { useRef } from "react";
import { useForm } from "react-hook-form";

// components
import ClassyDonateAmount from "./ClassyDonateAmount";
import ClassyDonateContactInfo from "./ClassyDonateContactInfo";
import Icon from "../Icon";

const formURL = "https://donate.panfoundation.org/give/293330/#!/donation/checkout";

const ClassyDonateForm = ({ impactFields }) => {
  const contactInfoEl = useRef();

  const { register, handleSubmit, errors, watch } = useForm();
  const amount = watch("amount") || "50";

  const handleNext = () => {
    window.scrollTo(0, contactInfoEl.current.offsetTop);
  };

  const handleSubmission = (formData) => {
    const passthroughParams = new URLSearchParams({
      amount:
        formData.amount === "other" ? formData.otherAmount.replace(/\$/g, '').replace(/,/g, '') : formData.amount,
      recurring: formData.recurring,
      first: formData.firstName,
      last: formData.lastName,
      email: formData.email,
      street: formData.address,
      city: formData.city,
      state: formData.state,
      zip: formData.zip,
      phone: formData.phone,
    });

    window.location = formURL + "?" + passthroughParams;
  };

  return (
    <form
      className="ClassyDonate-form u-form"
      onSubmit={handleSubmit(handleSubmission)}
    >
      <ClassyDonateAmount
        register={register}
        amount={amount}
        errors={errors}
        impactFields={impactFields}
      />
      <button
        className="ClassyDonate-btn btn"
        type="button"
        onClick={handleNext}
      >
        Next
      </button>

      <div ref={contactInfoEl}>
        <ClassyDonateContactInfo register={register} errors={errors} />
      </div>

      <button
        className="ClassyDonate-btn btn btn--icon btn--icon--left"
        type="submit"
      >
        Continue to payment
        <Icon name="lock" />
      </button>
    </form>
  );
};

export default ClassyDonateForm;
